import * as React from 'react';

export default React.createContext<{
  onFormClick: () => void;
} | null>(null);
